import request from '@/router/axios';
export function getDetail(id) {
  return request({
    url: '/system/lcdp/view/' + id,
    method: 'get',
  });
}

// 上报用户行为
export function updateRecord(data) {
  return request({
    url: '/system/monitor/record',
    globalErrMessage: false,
    globalLoading: false,
    method: 'post',
    data: data,
  });
}

// 获取指定客户端配置
export function getConfig(client) {
  return request({
    url: '/system/monitor/config/' + client,
    globalErrMessage: false,
    globalLoading: false,
    method: 'get',
  });
}
